import d3 = require('d3');
import L = require('leaflet');
import PieWidget from '../js/pieWidget.class.js';
import Waffle = require('../js/waffle.class.js');

require('../js/leaflet-gesture-handling.js');

import DeviceDetector = require('device-detector/dist/DeviceDetector.js');
import Selectr = require('mobius1-selectr/dist/selectr.min.js');

declare global {
  interface Window {
    // tslint:disable-line
    d3: any;
    L: any;
    Waffle: any;
    PieWidget: any;
    DeviceDetector: any;
    Selectr: any;
  }
}

window.d3 = window.d3 || d3;
window.L = window.L || L;
window.Waffle = window.Waffle || Waffle;
window.PieWidget = window.PieWidget || PieWidget;
window.DeviceDetector = window.DeviceDetector || DeviceDetector;
window.Selectr = window.Selectr || Selectr;

import 'd3-liquid-fill-gauge';

const NL_NL = {
  currency: ['€ ', ''],
  decimal: ',',
  grouping: [3],
  thousands: '.',
};
d3.formatDefaultLocale(NL_NL);

require('../wildsea/Scripts/main');

window.onload = () => {
  const event = new CustomEvent('BasisMonitorBootstrapped');
  const body = (document as any).getElementsByTagName('body')[0];
  body.dispatchEvent(event);
};

export class BasisMonitorApp {
  public ready(fn) {
    if ((document as any).attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
}
